/**
 * Preconnect hint for the main account API host (Run-UX plan PR-R). Every API
 * client in this app (storeClient, feedClient, launchClient, …) resolves the
 * SAME endpoint through the shared ConnectionProfile — this reads it from the
 * same resolver rather than introducing a second notion of the host, so the
 * hint always points at the host the feed/launch requests actually hit.
 *
 * Deliberately does NOT preconnect the per-session proxy host
 * (`<session-id>.app.ato.run`, see SessionConsole/embedded-session-console) —
 * that hostname is only known once a launch resolves an `appUrl`, so there is
 * no generic wildcard to preconnect ahead of time.
 */

import { accountApiBase } from "@/app/connection";

function apiHost(): string | null {
  const base = accountApiBase();
  try {
    return new URL(base).origin;
  } catch {
    return null;
  }
}

/** Idempotent — safe to call more than once (e.g. React StrictMode). */
export function preconnectApiHost(): void {
  if (typeof document === "undefined") return;
  const origin = apiHost();
  if (!origin) return;
  if (document.querySelector(`link[rel="preconnect"][href="${origin}"]`)) return;
  const link = document.createElement("link");
  link.rel = "preconnect";
  link.href = origin;
  document.head.appendChild(link);
}
